import Button from '@atlaskit/button'
import Heading from '@atlaskit/heading'
import * as React from 'react'
import { OtpCode } from '../components/OtpCode'
import { modalCss } from '../components/styles'
import { SendUIEvent, SendScreenEvent } from '../services/AnalyticsClient'
import { getAddonToken, getLocation, buildFilterParams, getUserTimezone } from '../services/JiraAP'
import Error from './Error'

function onModalClose() {
  window.AP.dialog.close()
  SendUIEvent('clicked', 'button', 'cancelError', 'openInGSheetsBlocked')
}

function reducer(prevState, newState) {
  return { ...prevState, ...newState }
}

export function OpenInGSheets() {
  const [state, setState] = React.useReducer(reducer, {
    targetUrl: '',
    popupsBlocked: false,
    error: false,
    jwt: undefined,
    authWindow: null,
    isSubscribedForOTP: false,
    queryParams: new URLSearchParams(),
  })

  React.useEffect(() => {
    async function prepareGSheetsQueryParams() {
      try {
        const locationUrl = new URL(await getLocation())
        const jql = locationUrl.searchParams.get('jql')
        const filterID = locationUrl.searchParams.get('filter')

        const [jwt, timeZone] = await Promise.all([getAddonToken(), getUserTimezone()])

        let queryParams = new URLSearchParams()

        if (filterID) {
          queryParams = await buildFilterParams(filterID)
        }
        if (jql) {
          queryParams.set('jql', jql)
        }

        queryParams.set('token', jwt)
        queryParams.set('timeZone', timeZone)

        setState({ jwt, queryParams })

        SendUIEvent(
          'clicked',
          'button',
          'jira.navigator.pluggable.items.openInGSheets',
          'jira.navigator.pluggable.items',
        )
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to open in GSheets', e)
        setState({ error: true })
      }
    }
    prepareGSheetsQueryParams()
  }, [])

  React.useEffect(() => {
    if (!state.isSubscribedForOTP) return

    try {
      const targetUrl = `/gsheet/file/start?${state.queryParams}`
      const authWindow = window.open(targetUrl, '_blank')

      if (authWindow) {
        setState({ authWindow })
      } else {
        setState({ targetUrl, popupsBlocked: true })
        SendScreenEvent('openInGSheetsBlocked')
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to open in GSheets', e)
      setState({ error: true })
    }
  }, [state.isSubscribedForOTP, state.jwt, state.queryParams, state.timeZone])

  const openGSheets = () => {
    try {
      const authWindow = window.open(state.targetUrl, '_blank')
      SendUIEvent('clicked', 'button', 'allowOpenInGSheets', 'openInGSheetsBlocked')
      setState({ authWindow, popupsBlocked: false })
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Failed to open In GSheets:', e)
      setState({ error: true })
    }
  }

  if (state.error) {
    return (
      <Error
        maxImageHeight={60}
        primaryAction={
          <Button appearance='primary' onClick={onModalClose}>
            Close
          </Button>
        }
      />
    )
  }

  if (state.popupsBlocked) {
    return (
      <section css={modalCss.wrapper}>
        <div css={modalCss.heading}>
          <Heading as='h1' level='h600'>
            Allow a new tab
          </Heading>
        </div>
        <div css={modalCss.body}>
          <p>
            Because of your pop-up blocker, Jira needs your permission to open Google Sheets in a
            new tab
          </p>
        </div>
        <div css={modalCss.footer}>
          <Button appearance='subtle' onClick={onModalClose}>
            Close
          </Button>
          <Button appearance='primary' onClick={openGSheets}>
            Allow
          </Button>
        </div>
      </section>
    )
  }

  return (
    <OtpCode
      authWindow={state.authWindow}
      jwt={state.jwt}
      updateIsSubscribedForOTP={(isSubscribedForOTP) => setState({ isSubscribedForOTP })}
    />
  )
}
